module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAMFBMVEUAAAD///////////////////////////////////////////////////////////87TQQwAAAAD3RSTlMABQ4Jxr3NoNGysalsZBV/act5AAAAK0lEQVQI12MAAgMg5uthYGRQ+85wTdl/I0O9608BBqn/gQwMzCEgSSUGBgCZwQfCi6uRcwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/checkbox.png
// module id = 303
// module chunks = 5